import Button from "components/ui/button";
import Picture from "components/ui/picture";
import { cdnURL } from "components/utils/cdn";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { DotsPattern } from "./dots-pattern";

const Banner = ({ className = "" }) => {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);

  const onImageLoaded = () => {
    setTimeout(() => {
      setImageLoaded(true);
    }, 100);
  };

  const onClick = () => {
    navigate("/cards");
  };

  return (
    <div className={`SSR-homepage-banner ${className}`}>
      <div className="banner-title-section">
        <h1 className="banner-title">Send online cards for any occasion</h1>
        <div>
          <Button onClick={onClick}>Browse All Cards</Button>
        </div>
        <div className="banner-pattern">
          <DotsPattern />
        </div>
      </div>
      <div className="banner-image-section">
        <Link className={`image-container ${imageLoaded ? "animate" : ""}`} to="/cards">
          <Picture
            src={cdnURL("img/rebuild/promote/homepage/default-promo-3.png")}
            has2x
            hasWebp
            alt="Wide selection of birthday cards"
            width={916}
            height={430}
            onLoaded={onImageLoaded}
            className="banner-image"
          />
          <Picture
            src={cdnURL("img/rebuild/promote/homepage/default-promo-mobile.png")}
            has2x
            hasWebp
            alt="Wide selection of birthday cards"
            width={356}
            height={356}
            onLoaded={onImageLoaded}
            className="banner-image-mobile"
          />
        </Link>
      </div>
    </div>
  );
};

Banner.propTypes = {
  className: PropTypes.string,
};

export default Banner;
